import React from "react";
import { useSelector } from "react-redux";
import { FaChevronUp, FaChevronDown } from "react-icons/fa";
import assignment from "../../assets/Thread/Assignment.jpg";
import { formatOrderCreatedDate, formatYYYY_MM_DD_HH_MM_A } from "../../utils/dateFormating";

const OrderDetails = ({
  tutorial,
  isExpanded,
  toggleSection,
  handleViewOrder,
}) => {
  const thread = useSelector((state) => state.thread);

  return (
    <div className="mt-[22px]">
      <div className="flex items-start justify-between ">
        <h1 className="ml-[20px] font-roboto font-semibold text-[18px] leading-5 text-primary mb-4">
          Order Details
        </h1>
        <div
          className="cursor-pointer mr-[22px]"
          onClick={toggleSection}
          aria-expanded={isExpanded}
        >
          {isExpanded ? (
            <FaChevronUp className="w-[20px] text-secondary" />
          ) : (
            <FaChevronDown className="w-[20px] text-secondary" />
          )}
        </div>
      </div>

      <div className="flex flex-row space-x-2 font-inter font-medium text-level-5 leading-3 text-secondary">
        <div className="ml-[20px]">
          <img
            src={assignment}
            alt="Assignment"
            className="w-[68px] h-[48px] rounded-[8px] border border-medium-gray"
          />
        </div>
        <div>
          <h1 className="font-inter text-secondary mt-[4px]  font-medium text-level-5">
            {thread?.selectedOrder?.orderRequirements?.subject}
          </h1>
          <button
            className="font-inter mt-[12px] font-medium text-level-5 leading-3 underline text-blue-shades"
            onClick={handleViewOrder} // Pass tutorial ID
          >
            View Order
          </button>
        </div>
      </div>

      <div className="mx-[14px] my-[24px] bg-[#E6E7EC] h-[1px] rounded-full"></div>

      {/* Expandable Section */}
      {isExpanded && (
        <div>
          <div className="mt-4 font-inter text-[12px] leading-3 font-medium text-secondary mx-[20px] space-y-2">
            <div className="flex justify-between">
              <span>Order ID</span>
              <span className="text-gray">{tutorial.roomId}</span>
            </div>
            <div className="flex justify-between">
              <span>Price</span>
              <span className="text-gray">${tutorial.price}</span>
            </div>
            <div className="flex justify-between">
              <span>Order Date</span>
              <span className="text-gray">
                {formatYYYY_MM_DD_HH_MM_A(tutorial?.createdAt)}
                {/* {tutorial.date}, {tutorial.time} */}
              </span>
            </div>
            <div className="flex justify-between">
              <span>Delivery Date</span>
              <span className="text-gray">
                {formatYYYY_MM_DD_HH_MM_A(tutorial?.deadline)}
                {/* {tutorial.ddate}, {tutorial.dtime} */}
              </span>
            </div>
          </div>

          <div className="mx-[14px] my-[24px] bg-[#E6E7EC] h-[1px] rounded-full"></div>
        </div>
      )}
    </div>
  );
};

export default OrderDetails;
